module.exports = __webpack_public_path__ + "images/sprites/ui/icon_check_sucess_7b5e4f8019839d26e6253a68580c4940.png";